/**
 * Determines whether a given trigger block is the one that should be updated.
 *
 * If `selectedGroupId` is provided, both the `groupId` and `triggerId` must match.
 * If `selectedGroupId` is not provided, only `triggerId` is used for comparison.
 *
 * @param {string | undefined} [selectedGroupId] - The group ID selected by the user (optional).
 * @param {string} selectedTriggerId - The ID of the trigger to find.
 * @param {string | undefined} [currentGroupId] - The current group ID being traversed.
 * @param {string} currentTriggerId - The ID of the current trigger block.
 * @returns {boolean} True if the current block matches the searched trigger.
 *
 * @example
 * isSearchedTriggerBlock('group-1', 'trigger-5', 'group-1', 'trigger-5'); // true
 * isSearchedTriggerBlock(undefined, 'trigger-5', undefined, 'trigger-5'); // true
 * isSearchedTriggerBlock('group-2', 'trigger-5', 'group-1', 'trigger-5'); // false
 */
export const isSearchedTriggerBlock = (selectedGroupId, selectedTriggerId, currentGroupId, currentTriggerId) => {
    if (selectedGroupId) {
        return currentGroupId === selectedGroupId && currentTriggerId === selectedTriggerId;
    }

    return currentTriggerId === selectedTriggerId;
};
